/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import {
    DragZoneUpload,
    ContentCard,
    TagsList,
} from '@fitinsur/components'
import {
    LoaderContext
} from '@fitinsur/contexts'

import Colors from "../../constants/Colors";

export default function VerifyDocsSigned({ permissions, match, ...props }) {
    const [pdfFile, setPdfFile] = useState(null);
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();

    return (
            <ContentCard title="Verfificar Assinatura De Documento ">
                <DragZoneUpload autoUpload
                    onSuccess={async (result) => {
                        setPdfFile(result)
                        let verification = await fitinsur.requestGetVerifyDocumentSigned(result[0].fileName).then(res => res.json() )
                        console.log(verification)
                        if(verification.ret_value.integrity){
                            mc.success('Documento Assinado!')
                        }else{
                            mc.error('Documento Não Assinado!')
                        }
                        updateIsLoadingStatus(false);
                    }}
                ></DragZoneUpload>
                <TagsList
                    customColor={Colors.SECONDARY}
                    tags={pdfFile}
                    disableType
                    removeTag={(index) => {
                        setPdfFile(null);
                    }}
                />
            </ContentCard>
    )
}